module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dawn-title-nav"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title-area"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.title))]), (_vm.subtitle) ? _c('p', {
    staticClass: "page-subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()]), (_vm.hasAction) ? _c('div', {
    staticClass: "action-area text-right"
  }, [_vm._t("action")], 2) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df46fb40","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/edTitleNav/index.vue
// module id = OHKV
// module chunks = 13 14